import React from 'react';

import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import router from 'src/routes';

import '../css/skjemautfyller.scss';

import type { AppStore } from '../store/reducers';

interface RootProps {
  store: AppStore;
}

export const Root = ({ store }: RootProps): React.JSX.Element => {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};
export default Root;
